
import React, {useState} from "react";
import "./Snapmint.css";
import './Hrone.css';
import './Medkart.css';
import medkart1 from '../../images/casestudies/Medkart1.webp';
import a from '../../images/casestudies/snapinv1.webp';
import b from '../../images/casestudies/Insitor.webp';

import c from '../../images/casestudies/alkemi.webp';
import d from '../../images/casestudies/Radixcap.webp';
import e from '../../images/casestudies/medkart.webp'

const FlipCard = ({ frontText, backContent }) => {
  return (
    <div className="flip-card">
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <p className="text-white ">{frontText}</p>
        </div>
        <div className="flip-card-back">
          {backContent}
        </div>
      </div>
    </div>
  );
};
const SnapmintPage = () => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSection = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="container my-5">
      <div className="roundBorder">
      
      <h2 className="titleServ">
      Medkart – A claimant to the 'most profitable Indian generic pharmacy chain' crown
              </h2>
              <div className="lineServ mt-30"></div>
      <div className=" mt-40">
      <div className="Med-container mt-5">
        <div>
            <img src={medkart1} />
        </div>

  <div className={isOpen ? "medkit-investor-section" : "medkit-investor-section2 "}>
    <div className="investors-card">
      <div className="investors-header">
        <span className={isOpen ? "title-open" : "title-closed "}>INVESTORS</span>
        <button className={isOpen ? "title-open toggle-button" : "title-closed toggle-button"} onClick={toggleSection}>
          {isOpen ? "-" : "+"}
        </button>
      </div>
      {isOpen && (
        <div className="medkart-investors-content">
            <div className="d-flex flex-row justify-content-center">
            
             <a href="https://prudentim.com/">
                                <img src={a} alt="Prudential" />
                                </a>
                                <a href="https://www.insitorpartners.com/">
                                <img src={b} alt="Kae Capital" />
                                </a>
            </div>
            <div className="d-flex flex-row justify-content-center" >
          
           <a href="https://www.alkemivp.com/">
                              <img src={c} alt="Prudential" />
                              </a>
                              <a href="https://radixcap.in/">
                              <img src={d} alt="Kae Capital" />
                              </a>
          
        </div>
        
        </div>
      )}
    </div>
  </div>
</div>

                  </div>

                 
                  <h2 className="titleServ mb-5 mt-5">
                  Looking beyond the wave (with an eye on fundamentals)

              </h2>
              <div className="lineServ mt-40"></div>
    <div className="card-container">
      <FlipCard
        frontText="Wave of Online Pharmacy – End of 2020"
        backContent={
          <div className="flip-back-card">
             <div className="hrone-list-2">
                        <ul >
            <li><strong>Online Pharmacy</strong> wave due to ease of convenience.</li>
            <li><strong>No thesis around Generic Pharmacy -</strong> Nobody changes their prescribed medicine brands in India.</li>
            
            </ul>
                </div>

          </div>
        }
      />
      <FlipCard
        frontText="Radix’s Fundamental Approach"
        backContent={
                    <div className="hrone-list-2">
            <ul >
            <li>India will be disrupted by <strong>generic wave similar to USA.</strong></li>
            <li>Generic pharmacy is a substitution business and not a distribution business like regular pharmacy. <strong>Offline model was the way to go!</strong></li>
            
            </ul>
       </div>
        }
      />
      
    </div>

       
    <h2 className="titleServ snap-title2">
    Medkart - A claimant to the ”most profitable Indian pharmacy chain” crown
              </h2>
              <div className="lineServ mt-40"></div>
      <div className="row my-4">
        <div className="col-md-6">
          <div className="">
            <img src={e} alt="Snapmint" />
            
          </div>
        </div>
        <div className="col-md-6">
          <div className="info-box">
            <h4 className="titleServ titleServ2">Medkart Today</h4>
            <div style={{"marginInlineStart":"160px"}} className="lineServ "></div>
            <p  className=" text-black fw-bold titleServ2 mt-5">3x </p>
              <p className=" text-black">Growth in Revenue</p>
                <p className=" text-black">(store mature in 12-15 months)</p>
              
            <p  className=" text-black fw-bold titleServ2">4x</p>
            <p className=" text-black">Growth in number of Stores</p>
            
          </div>
        </div>
      </div>
      <div className="text-center my-5">
          <a href="/neewee">
            <button className="btnArrow">
              <i className="fa-solid fa-arrow-left"></i> HROne
            </button>
          </a>
          &nbsp;&nbsp;
          <a href="/sukhhi">
            <button className="btnArrow">
              Sunsure <i className="fa-solid fa-arrow-right"></i>
            </button>
          </a>
        </div>
        </div>
    </div>
  );
};

export default SnapmintPage;

